"use strict";

exports.__esModule = true;
var _SelectedDevicesController = require("./SelectedDevicesController");
Object.keys(_SelectedDevicesController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectedDevicesController[key]) return;
  exports[key] = _SelectedDevicesController[key];
});